import React, { useEffect } from "react";
import "./errorpage.css";
import Error401Icon from "../../assets/img/svg/x401errorimage.svg";
import { useNavigate } from "react-router-dom";
import configJson from "../../Config.json";

const Error401Page = () => {
  const navigate = useNavigate();

  const signOutRedirect = () => {
    // const logoutUri = `${configJson.logout_uri}`;
    // window.location.href = `${configJson.cognitoDomain}/logout?client_id=${configJson.client_id
    //         }&logout_uri=${encodeURIComponent(logoutUri)}`;
    navigate('/');
  };

  useEffect(() => {
    if (localStorage.getItem("accessToken")) {
      localStorage.removeItem("accessToken");
    }
    sessionStorage.clear()
  }, []);

  const handleNavigation = () => {
    signOutRedirect()
  };
  return (
    <div className="error-pages-container">
      <img src={Error401Icon} alt="404 Error"></img>
      <h1>Your session has timed out for security reasons</h1>
      <p>Please log in again to continue using the application.</p>
      {/*<h1>Your Authorization failed</h1>*/}
      {/*<p>*/}
      {/*  <strong>Error 401 :</strong> Please Try refreshing the page and fill in*/}
      {/*  the correct login details.*/}
      {/*</p>*/}

      <button
        onClick={handleNavigation}
        className="error-accept-button"
      >
        Back To Home Page
      </button>
    </div>
  );
};

export default Error401Page;
